<app-auth-shell title="Entrar com código no e-mail" subtitle="Enviamos um código de 6 dígitos para o e-mail confirmado.">
  <form role="form" [formGroup]="formOtp" (ngSubmit)="verifyCode()">
    <div class="auth-field">
      <label class="auth-field__label" for="email">E-mail</label>
      <div class="auth-field__control">
        <input id="email" type="email" formControlName="email" class="auth-field__input" placeholder="nome@empresa.com" autocomplete="email" appFocus />
      </div>
      @if (formOtp.get('email')?.dirty) { @if (formOtp.get('email')?.hasError('required')) {
      <div class="auth-field__error">Campo obrigatório</div>
      } @if (formOtp.get('email')?.hasError('email')) {
      <div class="auth-field__error">E-mail inválido</div>
      } }
    </div>
    <div class="auth-field">
      <label class="auth-field__label" for="code">Código</label>
      <div class="auth-field__control">
        <input
          id="code"
          type="text"
          inputmode="numeric"
          formControlName="code"
          class="auth-field__input"
          placeholder="000000"
          maxlength="6"
          autocomplete="one-time-code"
        />
      </div>
      @if (formOtp.get('code')?.dirty) { @if (formOtp.get('code')?.hasError('required')) {
      <div class="auth-field__error">Campo obrigatório</div>
      } @if (formOtp.get('code')?.hasError('minLength') || formOtp.get('code')?.hasError('maxLength')) {
      <div class="auth-field__error">Informe os 6 dígitos</div>
      } } @if (hasRequestedCode && validitySeconds > 0) {
      <div class="auth-field__hint">Código válido por {{ formatCountdown(validitySeconds) }}</div>
      } @if (hasRequestedCode && validitySeconds === 0) {
      <div class="auth-field__error">Código expirado. Solicite outro.</div>
      }
    </div>
    <div class="auth-field__action">
      <button type="button" class="auth-link" (click)="requestCode()" [disabled]="remainingSeconds > 0">
        @if (remainingSeconds > 0) { Reenviar em {{ formatCountdown(remainingSeconds) }} } @else if (hasRequestedCode) { Reenviar código } @else { Enviar código
        }
      </button>
    </div>
    <button type="submit" class="auth-btn" [disabled]="!formOtp.valid || !hasRequestedCode || validitySeconds === 0">Entrar</button>
  </form>
  <div class="auth-shell__links">
    <p class="auth-shell__links-text">
      Prefere senha?
      <a class="auth-link" [routerLink]="['/signin']">Entrar</a>
    </p>
    <p class="auth-shell__legal">
      <a href="https://erpclass.com.br/" target="_blank" rel="noopener noreferrer">SOFTClass</a>
      ·
      <a href="https://erpclass.com.br/" target="_blank" rel="noopener noreferrer">erpclass.com.br</a>
    </p>
  </div>
</app-auth-shell>
